import axiosInstance from '@/services/axiosInstance'

async function importNeosPaD (data = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: '/api/importaciones/importarnotificacionespad',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
      },
      data,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { importNeosPaD }
